import AttributeTable from './attributes/AttributeTable';

export default AttributeTable;
